import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {AppRole, DeploymentAdminModel } from 'digiteq-ai-portal-client-lib';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { FormUtils } from '../../utils/form-utils';

@Component({
  selector: 'app-model-dialog',
  templateUrl: './model-dialog.component.html',
})
export class ModelDialogComponent implements OnInit {
  @Input() editedItem: DeploymentAdminModel | null = null;
  @Input() processing: boolean = false;

  @Output() onCancel = new EventEmitter<void>();
  @Output() onAddModel = new EventEmitter<DeploymentAdminModel>();
  @Output() onEditModel = new EventEmitter<DeploymentAdminModel>();

  newModelForm?: FormGroup;

  protected readonly rolesRestrictionOptions: string[] = Object.values(AppRole);

  constructor(
    private readonly fb: FormBuilder,
    private readonly messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.newModelForm = this.fb.group({
      modelFriendlyName: [this.editedItem?.modelFriendlyName || '', Validators.required],
      deploymentName: [
        this.editedItem?.deploymentName || '',
        Validators.required,
      ],
      modelType: [this.editedItem?.modelType || '', Validators.required],
      endpoint: [this.editedItem?.endpoint || '', Validators.required],
      prompt: [
        this.editedItem?.prompt || '',
        Validators.required,
      ],
      maxInputTokens: [
        this.editedItem?.maxInputTokens || '',
        Validators.required,
      ],
      maxResponseTokens: [
        this.editedItem?.maxResponseTokens || '',
        Validators.required,
      ],
      restriction: [this.editedItem?.restriction || false],
      enabled: [this.editedItem?.enabled || true],
      rolesRestriction: [this.editedItem?.rolesRestriction || ''],
      note: [this.editedItem?.note || ''],
      default: [this.editedItem?.default || false],
      isSummary: [this.editedItem?.isSummary || false],
      embeddingModel: [this.editedItem?.embeddingModel || false],
    });
    if (this.editedItem?.id) {
      this.newModelForm.addControl('id', this.fb.control(this.editedItem.id));
    }

    this.newModelForm.get('restriction').valueChanges.subscribe((restriction) => {
      if (restriction) {
        this.newModelForm.get('rolesRestriction').addValidators(Validators.required);
        this.newModelForm.get('note').addValidators(Validators.required);
      } else {
        this.newModelForm.get('rolesRestriction').reset();
        this.newModelForm.get('rolesRestriction').clearValidators();
        this.newModelForm.get('note').reset();
        this.newModelForm.get('note').clearValidators();
      }

      this.newModelForm.get('rolesRestriction').markAsTouched();
      this.newModelForm.get('rolesRestriction').updateValueAndValidity();

      this.newModelForm.get('note').markAsTouched();
      this.newModelForm.get('note').updateValueAndValidity();
    })
  }

  onDialogCancel() {
    this.newModelForm.reset();
    this.onCancel.emit();
  }

  onSubmit() {
    if (
      !FormUtils.checkIfFormGroupValid(this.newModelForm, this.messageService)
    ) {
      return;
    }

    if (!this.editedItem) {
      this.createModel(this.newModelForm.value);
    } else {
      this.updateModel(this.newModelForm.value);
    }
  }

  createModel(model: DeploymentAdminModel) {
    this.onAddModel.emit(model);
  }

  updateModel(model: DeploymentAdminModel) {
    this.onEditModel.emit(model);
  }

  isDefault() {
    return this.newModelForm.value['default'];
  }

  isSummary() {
    return this.newModelForm.value['isSummary'];
  }

  isEmbeddingModel() {
    return this.newModelForm.value['embeddingModel'];
  }
}
